export var parseFileSize = function parseFileSize(size) {
  switch (true) {
    case size === undefined:
      return '';

    case size < 1000:
      return "".concat(size, "B");

    case size < 1000000:
      return "".concat(Number(size / 1000).toFixed(2), "KB");

    case size < 1000000000:
      return "".concat(Number(size / 1000000).toFixed(2), "MB");

    case size < 1000000000000:
      return "".concat(Number(size / 1000000000).toFixed(2), "GB");

    default:
      return ">1000GB";
  }
};
export function classifyType(type) {
  if (type.includes('image')) {
    return 'image';
  }

  if (type.includes('video')) {
    return 'video';
  }

  if (type.includes('pdf')) {
    return 'pdf';
  }

  return 'unknown';
}